import React from 'react';
import ChatPanelSourcesHeader from './ChatPanelSourcesHeader';
import SourceChatPanelList, { SourceItem } from './SourceChatPanelList';
import './ChatPanelSources.css';

interface ChatPanelSourcesProps {
  isVisible: boolean;
  sources?: SourceItem[];
  onClose?: () => void;
  floating?: boolean;
}

// Dummy sources data


const ChatPanelSources: React.FC<ChatPanelSourcesProps> = ({ isVisible, sources, onClose, floating = false }) => {
  if (!isVisible) return null;

  return (
    <div className={`chat-panel-sources ${floating ? 'floating' : ''}`}>
      <ChatPanelSourcesHeader
        sourceCount={sources?.length || 0}
        onClose={onClose || (() => {})}
      />
      <SourceChatPanelList sources={sources || []} />
    </div>
  );
};

export default ChatPanelSources;
